module.exports = __webpack_public_path__ + "img/free.d0ca77d.png";